var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy2 = function SvgCopy2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.833 16.667A4.172 4.172 0 0 0 15 12.5V5.203a3.31 3.31 0 0 0-.977-2.358L12.155.977A3.309 3.309 0 0 0 9.797 0H5.833a4.172 4.172 0 0 0-4.167 4.167V12.5a4.172 4.172 0 0 0 4.167 4.167h5Zm-7.5-4.167V4.167a2.5 2.5 0 0 1 2.5-2.5s4.1.011 4.167.02v1.646A1.666 1.666 0 0 0 11.666 5h1.647c.008.068.02 7.5.02 7.5a2.5 2.5 0 0 1-2.5 2.5h-5a2.5 2.5 0 0 1-2.5-2.5Zm15-5.833v9.166A4.172 4.172 0 0 1 14.167 20h-7.5a.833.833 0 1 1 0-1.667h7.5a2.5 2.5 0 0 0 2.5-2.5V6.667a.833.833 0 1 1 1.666 0Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCopy2;